import { useState, useEffect } from "react";
import moment from "moment";
import { formatDate } from "../../../../utils/DateUtils";

import Breadcrumbs from "../../../components/Breadcrumbs";
import SearchAndFilter from "../../../components/Search/SearchAndFilter";
import Pagination from "../../../components/Footer/Pagination";
import Topbar from "../../../components/Topbar";
import {
  getDataWithComp,
  formatCurrency,
  getViewAp,
} from "../../../../utils/SamuiUtils";
import { getReport } from "../../../../utils/ReportUtils";
import WtaxModal from "../../../components/Modal/WtaxModal";
import {
  useDataTableKeyboardNavigation,
  getDataTableRowStyle,
  getDataTableKeyboardInstructions,
} from "../../../../utils/DataTableKeyboardNavigation";
import { payMasterModel } from "../../../../model/Purchase/PayMasterModel";

const STORAGE_KEYS = {
  searchTerm: "taxSearchTerm",
  startDate: "taxStartDate",
  endDate: "taxEndDate",
  currentPage: "taxCurrentPage",
  itemsPerPage: "taxItemsPerPage",
};

const Main = ({ name, dataMasterList }) => {
  const [filteredItems, setFilteredItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEYS.currentPage);
    return stored ? parseInt(stored, 10) : 1;
  });
  const [itemsPerPage, setItemsPerPage] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEYS.itemsPerPage);
    return stored ? parseInt(stored, 10) : 10;
  });

  const [searchTerm, setSearchTerm] = useState(
    localStorage.getItem(STORAGE_KEYS.searchTerm) || ""
  );
  const [startDate, setStartDate] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEYS.startDate);
    return stored || moment().startOf("month").format("YYYY-MM-DD");
  });
  const [endDate, setEndDate] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEYS.endDate);
    return stored || moment().endOf("month").format("YYYY-MM-DD");
  });

  const [selectedRowIndex, setSelectedRowIndex] = useState(0);
  const [showWTModal, setShowWTModal] = useState(false);
  const handleWTClose = () => setShowWTModal(false);
  const [apDataList, setApDataList] = useState([]);
  const [, setTotalWT] = useState(0);
  const [, setInputValueTotalWT] = useState("0.00");
  const [selectedOption, setSelectedOption] = useState(1);
  const currentDate = formatDate(new Date());
  const [taxData, setTaxData] = useState([
    {
      id: 1,
      type: 5,
      percent: 3.0,
      date: currentDate,
      amount: 0.0,
      tax: 0.0,
      remark: "",
    },
    {
      id: 2,
      type: 6,
      percent: 3.0,
      date: currentDate,
      amount: 0.0,
      tax: 0.0,
      remark: "",
    },
  ]);
  const [, setTaxtotalAmount] = useState(0);
  const [formMasterList, setFormMasterList] = useState([payMasterModel()]);
  const [docRef, setDocRef] = useState("");
  const [Ref_PAY_ID, setRef_PAY_ID] = useState();
  const [mode, setMode] = useState("I");

  useEffect(() => {
    try {
      const source = Array.isArray(dataMasterList) ? [...dataMasterList] : [];
      const start = moment(startDate, "YYYY-MM-DD");
      const end = moment(endDate, "YYYY-MM-DD");

      const filteredByDate = source.filter((item) => {
        const itemDate = moment(item.WTAX_Date);
        return itemDate.isBetween(start, end, null, "[]");
      });

      const search = searchTerm.trim().toLowerCase();
      const filtered = search
        ? filteredByDate.filter(
          (item) =>
            (item.WTAX_No && item.WTAX_No.toLowerCase().includes(search)) ||
            (item.AP_Name && item.AP_Name.toLowerCase().includes(search)) ||
            (item.Ref_Doc && item.Ref_Doc.toLowerCase().includes(search))
        )
        : filteredByDate;

      setFilteredItems(filtered);
    } catch (error) {
      console.error("Filter error:", error.message);
      setFilteredItems([]);
    }

    setCurrentPage(1);
    setSelectedRowIndex(0);
    localStorage.setItem(STORAGE_KEYS.currentPage, "1");
    localStorage.setItem(STORAGE_KEYS.searchTerm, searchTerm);
    localStorage.setItem(STORAGE_KEYS.startDate, startDate);
    localStorage.setItem(STORAGE_KEYS.endDate, endDate);
  }, [dataMasterList, searchTerm, startDate, endDate]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setSelectedRowIndex(0);
    localStorage.setItem(STORAGE_KEYS.currentPage, String(pageNumber));
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    const fetchApList = async () => {
      const apData = await getViewAp();
      if (Array.isArray(apData) && apData.length > 0) {
        setApDataList(apData);
      }
    };

    if (Array.isArray(dataMasterList) && dataMasterList.length > 0) {
      fetchApList();
    }
  }, [dataMasterList]);

  const onRowSelected = (fromData, index = -1) => {
    let selectedData;
    if (typeof fromData === "string" || typeof fromData === "number") {
      selectedData = currentItems.find((item) => item.WTAX_Id === fromData);
      if (selectedData) {
        const foundIndex = currentItems.findIndex(
          (item) => item.WTAX_Id === fromData
        );
        setSelectedRowIndex(foundIndex);
      }
    } else {
      selectedData = fromData;
      setSelectedRowIndex(index);
    }

  };

  const handlePrintReport = (wtaxId) => {
    try {
      getReport("TAX", wtaxId);
    } catch (error) {
      console.error("Error in getReport:", error);
    }
  };

  const fieldMappings = {
    no: "WTAX_Id",
  };

  useDataTableKeyboardNavigation(
    true,
    currentItems,
    selectedRowIndex,
    setSelectedRowIndex,
    onRowSelected,
    fieldMappings,
    currentPage,
    handlePageChange,
    filteredItems.length,
    itemsPerPage,
    handlePrintReport,
    {
      customKeyHandlers: {
        Enter: (event) => {
          event.preventDefault();
          if (currentItems[selectedRowIndex]) {
            update(currentItems[selectedRowIndex].WTAX_No);
          }
        },
        p: (event) => {
          event.preventDefault();
          if (currentItems[selectedRowIndex]) {
            handlePrintReport(currentItems[selectedRowIndex].WTAX_Id);
          }
        },
        P: (event) => {
          event.preventDefault();
          if (currentItems[selectedRowIndex]) {
            handlePrintReport(currentItems[selectedRowIndex].WTAX_Id);
          }
        },
      },
    }
  );

  const Type = (type) => {
    switch (type) {
      case 1:
        return "ภ.ง.ด.1ก.";
      case 2:
        return "ภ.ง.ด.1ก.พิเศษ";
      case 3:
        return "ภ.ง.ด.2";
      case 4:
        return "ภ.ง.ด.3";
      case 5:
        return "ภ.ง.ด.2ก.";
      case 6:
        return "ภ.ง.ด.3ก.";
      case 7:
        return "ภ.ง.ด.53";
      default:
        return "ไม่พบข้อมูล";
    }
  };

  const Insert = () => {
    setMode("I");
    setFormMasterList([payMasterModel()]);
    setDocRef("");
    const now = formatDate(new Date());
    setTaxData([
      {
        id: 1,
        type: 5,
        percent: 3.0,
        date: now,
        amount: 0.0,
        tax: 0.0,
        remark: "",
      },
      {
        id: 2,
        type: 6,
        percent: 3.0,
        date: now,
        amount: 0.0,
        tax: 0.0,
        remark: "",
      },
    ]);
    setSelectedOption(3);
    setShowWTModal(true);
  };

  const update = async (data) => {
    try {
      const tax = await getDataWithComp(
        "API_1701_WTAX_H",
        `and WTAX_No = '${data}'`
      );

      const taxD = await getDataWithComp(
        "API_1702_WTAX_D",
        `and WTAX_No = '${data}'`
      );

      if (!tax || tax.length === 0) {
        console.warn("ไม่พบข้อมูล WTAX");
        return;
      }

      const taxItem = tax[0] || {};
      const taxItemD = taxD[0] || {};

      setDocRef(taxItem?.Ref_Doc);
      setRef_PAY_ID(
        taxItem?.Ref_Doc?.startsWith("PAY") ? taxItem?.Ref_Doc : null
      );

      setFormMasterList((prevState) => ({
        ...prevState,
        payId: taxItem?.Pay_Id,
        apID: taxItem?.AP_Id,
        apCode: taxItem?.AP_Code,
        apName: taxItem?.AP_Name,
        apAdd1: taxItem?.AP_Add1,
        apAdd2: taxItem?.AP_Add2,
        apAdd3: taxItem?.AP_Add3,
        apProvince: taxItem?.AP_Province,
        apZipcode: taxItem?.AP_Zipcode,
        apTaxNo: taxItem?.AP_TaxNo,
      }));

      const formattedDate = taxItemD?.WTAX_Date
        ? moment.utc(taxItemD.WTAX_Date).format("DD/MM/YYYY")
        : "";

      setTaxData([
        {
          id: 1,
          type: taxItemD?.WTAX_TypeNo || "",
          percent: taxItemD?.WTAX_Percent || 0,
          date: formattedDate,
          amount: taxItemD?.WTAX_Total || 0,
          tax: taxItemD?.WTAX_Total_Tax || 0,
          remark: taxItemD?.WTAX_Desc || "",
          Wtax_Id: taxItem?.WTAX_Id || "",
          Wtax_No: taxItem?.WTAX_No || "",
        },
      ]);
      setSelectedOption(taxItem.WTAX_Type || 1);
      setMode("U");
      setShowWTModal(true);
    } catch (error) {
      console.error("เกิดข้อผิดพลาดในการโหลดข้อมูลภาษี:", error);
    }
  };

  return (
    <>
      <Topbar
        breadcrumbs={[
          { label: "จัดซื้อสินค้า", link: "/purchase-order" },
          { label: name },
        ]}
      />
      <Breadcrumbs
        page={name}
        items={[
          { name: "จัดซื้อสินค้า", url: "/purchase-order" },
          { name: name, url: "/tax" },
        ]}
      />
      <div
        className="container-fluid card py-3 hidden-scrollbar"
        style={{ maxHeight: "80vh", overflowY: "auto" }}
      >
        <SearchAndFilter
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          searchPlaceholder="ค้นหาเลขเอกสาร, ผู้ถูกหักภาษี, เอกสารอ้างอิง..."
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          showDateFilter={true}
          onAddNew={Insert}
          addButtonText={`สร้าง${name}`}
          showAddButton={true}
        />
        <WtaxModal
          showWTModal={showWTModal}
          handleWTClose={handleWTClose}
          apDataList={apDataList}
          setTotalWT={setTotalWT}
          setInputValueTotalWT={setInputValueTotalWT}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
          taxData={taxData}
          setTaxData={setTaxData}
          setTaxtotalAmount={setTaxtotalAmount}
          formMasterList={formMasterList}
          setFormMasterList={setFormMasterList}
          docRef={docRef}
          setDocRef={setDocRef}
          Ref_PAY_ID={Ref_PAY_ID}
          setRef_PAY_ID={setRef_PAY_ID}
          mode={mode}
        />
        <hr />
        <div className="row">
          <div className=" mb-1" style={{ borderRight: "2px solid #c7c8c9" }}>
            <div
              className="table-responsive"
              style={{ maxHeight: "650px", overflowY: "auto" }}
            >
              <table
                id="basic-datatables"
                className="table table-striped table-hover"
              >
                <thead className="thead-dark">
                  <tr>
                    <th className="text-center" style={{ width: "3%" }}>
                      #
                    </th>
                    <th className="text-center" style={{ width: "10%" }}>
                      เลขที่เอกสาร
                    </th>
                    <th className="text-center" style={{ width: "30%" }}>
                      ผู้ถูกหักภาษี ณ ที่จ่าย
                    </th>
                    <th className="text-center" style={{ width: "10%" }}>
                      เอกสารอ้างอิง
                    </th>
                    <th className="text-center" style={{ width: "10%" }}>
                      ประเภทแบบ
                    </th>
                    <th className="text-center" style={{ width: "10%" }}>
                      วันที่ออก
                    </th>

                    <th className="text-center" style={{ width: "10%" }}>
                      ยอดเงินรวม
                    </th>
                    <th className="text-center" style={{ width: "10%" }}>
                      ยอดหักภาษี
                    </th>
                    <th className="text-center" style={{ width: "1%" }}>
                      แก้ไข
                    </th>
                    <th
                      className="text-center"
                      style={{ width: "1%" }}
                      hidden={
                        window.location.pathname === "/payment-voucher" ||
                        window.location.pathname === "/picking-list"
                      }
                    >
                      พิมพ์
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {filteredItems.length > 0 ? (
                    currentItems.map((data, index) => (
                      <tr
                        key={data.WTAX_Id || index + 1}
                        onClick={() => onRowSelected(data, index)}
                        style={getDataTableRowStyle(
                          index,
                          selectedRowIndex,
                          null,
                          data,
                          "WTAX_Id"
                        )}
                      >
                        <td className="text-center">
                          {indexOfFirstItem + index + 1}
                        </td>
                        <td className="text-center">{data.WTAX_No}</td>
                        <td className=""> {data.AP_Name || "-"}</td>
                        <td className="text-center">{data.Ref_Doc || "-"}</td>
                        <td className="text-center">
                          {Type(data.WTAX_Type) || "-"}
                        </td>
                        <td className="text-center">
                          {moment.utc(data?.WTAX_Date).format("DD/MM/YYYY")}
                        </td>
                        <td className="text-end">
                          {formatCurrency(data?.WTAX_Total)}
                        </td>
                        <td className="text-end">
                          {formatCurrency(data?.WTAX_Total_Tax)}
                        </td>
                        <td className="text-center">
                          <button
                            className="btn btn-sm"
                            onClick={() => update(data.WTAX_No)}
                          >
                            <i
                              className="fa fa-edit"
                              style={{ color: "rgb(239, 108, 0)" }}
                            />
                          </button>
                        </td>
                        <td className="text-center">
                          <button
                            className="btn btn-link btn-sm px-3"
                            onClick={() => {
                              getReport("TAX", data.WTAX_Id);
                            }}
                          >
                            <i
                              className="fa fa-print"
                              style={{ fontSize: "16px" }}
                            ></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="10">
                        <center>
                          <h5>ไม่พบข้อมูล</h5>
                        </center>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="bg-white mt-2" style={{ padding: "8px 0" }}>
              <div className="row m-0">
                <div className="col-12 d-flex justify-content-between align-items-center flex-wrap py-2">
                  <div className="d-flex align-items-center flex-wrap">
                    <span className="me-2">แสดง:</span>
                    <select
                      className="form-select me-2"
                      style={{ width: "auto", minWidth: "70px" }}
                      value={itemsPerPage}
                      onChange={(e) => {
                        const newItemsPerPage = parseInt(e.target.value, 10);
                        setItemsPerPage(newItemsPerPage);
                        localStorage.setItem(
                          STORAGE_KEYS.itemsPerPage,
                          String(newItemsPerPage)
                        );
                        setCurrentPage(1);
                        setSelectedRowIndex(0);
                        localStorage.setItem(STORAGE_KEYS.currentPage, "1");
                      }}
                    >
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                    <span>
                      รายการต่อหน้า | แสดง {indexOfFirstItem + 1} ถึง {" "}
                      {Math.min(indexOfLastItem, filteredItems.length)} จาก {" "}
                      {filteredItems.length} รายการ
                    </span>
                  </div>
                  <div className="d-flex align-items-center flex-wrap">
                    <Pagination
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      itemsPerPage={itemsPerPage}
                      dataMasterList={filteredItems}
                      handlePageChange={handlePageChange}
                    />
                  </div>
                </div>
                <div className="text-muted" style={{ fontSize: "12px" }}>
                  {getDataTableKeyboardInstructions(false, true)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Main;
